import { render, staticRenderFns } from "./MakersSearch.vue?vue&type=template&id=65cd0e8d&"
import script from "./MakersSearch.vue?vue&type=script&lang=js&"
export * from "./MakersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports